import { loadGTM } from './gtm-loader';

export const pushToDataLayer = async (data: Record<string, unknown>) => {
  try {
    await loadGTM();
    const dataLayer = window.dataLayer;

    if (dataLayer.some(item => item.event_data) && data.event_data) {
      const emptyEvent = { event_data: null };

      dataLayer.push(emptyEvent);
      console.debug("## GTM - pushToDataLayer", emptyEvent);
    }

    dataLayer.push(data);
    console.debug("## GTM - pushToDataLayer", data);
  } catch (error) {
    console.warn(
      "## GTM - Loading script error. Unable to push to DataLayer.",
      error,
    );
  }
};
